import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  type FleetsListVessel,
  FleetType,
  VesselListOwnershipType,
} from '../../fleets.model';

interface DeleteFleetState {
  deleteFleetsDialogOpen: boolean;
  loading: boolean;
  success: boolean;
  error: boolean;
  currentFleets: string[];
  fleetName: string;
  fleetId: string;
  vesselListOwner: VesselListOwnershipType;
  fleetType: FleetType;
  fleetVessels: FleetsListVessel[];
  fleetVesselIds: string[];
}

export const INITIAL_DELETE_FLEET_STATE: DeleteFleetState = {
  deleteFleetsDialogOpen: false,
  loading: false,
  success: false,
  error: false,
  currentFleets: [],
  fleetName: '',
  fleetId: '',
  vesselListOwner: VesselListOwnershipType.Personal,
  fleetType: FleetType.Static,
  fleetVessels: [],
  fleetVesselIds: [],
};

const DeleteFleetsDialogSlice = createSlice({
  name: 'delete fleets dialog',
  initialState: INITIAL_DELETE_FLEET_STATE,
  reducers: {
    setDeleteFleetDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.deleteFleetsDialogOpen = action.payload;
    },
    setDeleteLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setDeleteSuccess: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload;
    },
    setDeleteError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
    setDeleteFleetData(
      state,
      action: PayloadAction<{
        fleetName: string;
        fleetId: string;
        vesselListOwner: VesselListOwnershipType;
        fleetType: FleetType;
        fleetVessels: FleetsListVessel[];
        fleetVesselIds: string[];
      }>
    ) {
      state.fleetName = action.payload.fleetName;
      state.fleetId = action.payload.fleetId;
      state.fleetType = action.payload.fleetType;
      state.vesselListOwner = action.payload.vesselListOwner;
      state.fleetVessels = action.payload.fleetVessels;
      state.fleetVesselIds = action.payload.fleetVesselIds;
    },
    setDeleteVesselsData(
      state,
      action: PayloadAction<{
        fleetVesselIds: string[];
      }>
    ) {
      state.fleetVesselIds = action.payload.fleetVesselIds;
    },
    resetDeleteState() {
      return INITIAL_DELETE_FLEET_STATE;
    },
  },
});

export const {
  setDeleteFleetDialogOpen,
  setDeleteLoading,
  setDeleteSuccess,
  setDeleteError,
  setDeleteFleetData,
  setDeleteVesselsData,
  resetDeleteState,
} = DeleteFleetsDialogSlice.actions;

export default DeleteFleetsDialogSlice.reducer;
